import React from "react";
import "./Common_Banner.css";

const Common_Banner = ({
  image,
  title,
  subtitle,
  overlayColor = "rgb(32 51 107 / 60%)",
}) => {
  return (
    <section
      className="CommonBanner"
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
      <div
        className="CommonBanner_overlay"
        style={{
          backgroundColor: overlayColor,
        }}
      ></div>

      <div className="CommonBanner_content">
        {title && <h1 className="title">{title}</h1>}

        {subtitle && <p className="subtitle">{subtitle}</p>}
      </div>
    </section>
  );
};

export default Common_Banner;
